import { createFileRoute, Outlet } from "@tanstack/react-router";
import { requireAuth } from "~/utils/authGuard";

/**
 * Auth-guard layout. All authenticated routes nest under it; unauthenticated
 * visitors are redirected to /sign-in?redirect=<path> (replaces the Next
 * middleware session check).
 *
 * `beforeLoad` returns synchronously once auth is cached (see requireAuth) so
 * in-app navigations don't become deferred/pending transitions.
 */
export const Route = createFileRoute("/_authed")({
  beforeLoad: ({ location }) => requireAuth(location.href),
  component: () => <Outlet />,
});
